"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringList = exports.FilteringListMessages = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var Flexbox_1 = require("../../styles/Flexbox");
var TabStyles_1 = require("../../styles/TabStyles");
var BrowserDetection_1 = require("../../utils/BrowserDetection");
var DomUtil_1 = require("../../utils/DomUtil");
var LiveAnnouncer_1 = require("../../utils/LiveAnnouncer");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var DropdownOverlay_1 = require("../Dropdown/DropdownOverlay");
var TextFieldWidget_1 = require("../TextField/TextFieldWidget");
var List_1 = require("./List");
var ListItemUtils_1 = require("./ListItemUtils");
var ListStyles_1 = require("./ListStyles");
exports.FilteringListMessages = Object.freeze({
    noMatches: Localize_1.Messages.noMatches,
    optionCountAnnouncement: Localize_1.Messages.optionCountAnnouncement,
});
var FieldWrapperStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.FlexShrink0), { padding: TabStyles_1.TabStyles.Spacing.SmallSpace }));
var FieldStyle = {
    width: '100%',
};
/**
 * Use `FilteringList` when it's necessary to have custom filtering logic, e.g. when the filtering is done server-side, or for custom formatting
 * of the items based on filtering results. Otherwise most cases will probably just want `LocallyFilteringList`.
 */
var FilteringList = /** @class */ (function (_super) {
    tslib_1.__extends(FilteringList, _super);
    function FilteringList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.announceTimeoutId = 0;
        _this.defaultListId = DomUtil_1.generateId();
        _this.listId = function () { return _this.props.listId || _this.defaultListId; };
        _this.defaultLabelId = DomUtil_1.generateId();
        _this.labelId = function () { return _this.props.labelId || _this.defaultLabelId; };
        _this.listRef = React.createRef();
        _this.state = {
            activeItemIndex: -1,
            focusWithin: false,
            width: undefined,
        };
        _this.handleBlur = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (!e.currentTarget.contains(DomUtil_1.findBlurRelatedTarget(e))) {
                _this.setState({ activeItemIndex: -1, focusWithin: false });
            }
        }, function (e) { var _a, _b; return (_b = (_a = _this.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.handleFocusCapture = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.setState({ focusWithin: true });
            if (_this.inputElement && e.target !== _this.inputElement) {
                _this.inputElement.focus();
                _this.setState({ activeItemIndex: _this.listRef.current.getActiveItemIndex() }); // don't let it get out of sync
            }
        }, function (e) { var _a, _b; return (_b = (_a = _this.props).onFocusCapture) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.clearInput = function () {
            var _a, _b;
            (_b = (_a = _this.props).onFilterChange) === null || _b === void 0 ? void 0 : _b.call(_a, '');
            _this.setState({ activeItemIndex: -1 });
        };
        _this.handleInputChange = function (e) {
            var _a, _b;
            _this.setState({ activeItemIndex: -1 }); // reset aria-activedescendant when filtering
            (_b = (_a = _this.props).onFilterChange) === null || _b === void 0 ? void 0 : _b.call(_a, e.target.value);
        };
        _this.handleInputFocus = function () { return _this.announceOptionCount(5000); };
        _this.handleInputBlur = function () { return window.clearTimeout(_this.announceTimeoutId); };
        _this.keyUpHandlers = {};
        _this.handleKeyUp = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (_this.keyUpHandlers[e.key]) {
                _this.keyUpHandlers[e.key](e);
                delete _this.keyUpHandlers[e.key];
                e.stopPropagation();
                e.preventDefault();
            }
        }, function (e) { var _a, _b; return (_b = (_a = _this.props).onKeyUp) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.keyDownHandlers = Object.freeze({
            'Ctrl+a': function () {
                if (_this.state.activeItemIndex > -1 && _this.props.selectedValues && _this.props.onSelectAll) {
                    _this.props.onSelectAll();
                    return false;
                }
                return true;
            },
            'Ctrl+Home': function () { return _this.moveSelection(-1, +1); },
            'Ctrl+End': function () { return _this.moveSelection(_this.props.items.length, -1); },
            'ArrowUp': function () { return _this.moveSelection(_this.state.activeItemIndex, -1); },
            'ArrowDown': function () { return _this.moveSelection(_this.state.activeItemIndex, +1); },
            'Enter': function () {
                var _a, _b;
                if (_this.state.activeItemIndex > -1 && _this.props.onSelect) {
                    var activeItem = _this.props.items[_this.state.activeItemIndex];
                    if (ListItemUtils_1.isSelectableItem(activeItem)) {
                        (_b = (_a = _this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, activeItem.value);
                    }
                }
            },
            'Escape': function (e) {
                if (_this.state.activeItemIndex > -1) {
                    if (!e.repeat) {
                        _this.keyUpHandlers[e.key] = function () { return _this.setState({ activeItemIndex: -1 }); };
                    }
                    return false;
                }
                return true;
            }
        });
        _this.handleKeyDown = ReactHelpers_1.mergeEventHandlers(function (e) {
            var key = (BrowserDetection_1.isCtrl(e) ? 'Ctrl+' : '') + e.key;
            if (_this.keyDownHandlers[key]) {
                if (!_this.keyDownHandlers[key](e)) { // handler returning falsy means the event was handled
                    e.stopPropagation();
                    e.preventDefault();
                }
            }
        }, function (e) { var _a, _b; return (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.handleDivRef = function (ref) {
            if (!ref) {
                _this.setState({ width: undefined });
            }
            else {
                // pin the width to prevent the widget from shrinking when items are filtered
                window.setTimeout(function () {
                    if (document.body.contains(ref)) {
                        _this.setState({ width: Math.ceil(ref.getBoundingClientRect().width) });
                    }
                });
            }
        };
        _this.updateInputRef = function (ref) {
            _this.inputElement = ref;
        };
        return _this;
    }
    FilteringList.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b;
        var items = this.props.items;
        var _c = this.state, activeItemIndex = _c.activeItemIndex, focusWithin = _c.focusWithin;
        if (prevProps.items !== items) {
            if (focusWithin) {
                this.announceOptionCount();
            }
            // preserve active item after filtering
            var activeItemValue = (_b = (_a = prevProps.items) === null || _a === void 0 ? void 0 : _a[prevState.activeItemIndex]) === null || _b === void 0 ? void 0 : _b.value;
            this.setState({ activeItemIndex: ListItemUtils_1.findIndexOfItemWithValue(items, activeItemValue) });
        }
        if (prevState.activeItemIndex !== activeItemIndex) {
            this.listRef.current.setActiveItemIndex(activeItemIndex);
        }
    };
    FilteringList.prototype.componentDidMount = function () {
        var _this = this;
        this.listRef.current.setActiveItemIndex(this.state.activeItemIndex);
        window.setTimeout(function () {
            var _a, _b;
            var firstSelectedItemIndex = ListItemUtils_1.findIndexOfItemWithValue(_this.props.items, _this.getFirstSelectedValue());
            (_a = _this.listRef.current) === null || _a === void 0 ? void 0 : _a.scrollItemIndexIntoView(firstSelectedItemIndex);
            if (_this.props.autoFocus) {
                (_b = _this.inputElement) === null || _b === void 0 ? void 0 : _b.focus();
            }
        });
    };
    FilteringList.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.announceTimeoutId);
    };
    /** Gets the index into `props.items` of the pseudo-focused listbox option. */
    FilteringList.prototype.getActiveItemIndex = function () {
        return this.state.activeItemIndex;
    };
    /** Debounced announcement of option count, to avoid reading a new count with every keystroke while the user is still typing. */
    FilteringList.prototype.announceOptionCount = function (timeout) {
        if (timeout === void 0) { timeout = 2000; }
        window.clearTimeout(this.announceTimeoutId); // it's a safe noop to call clearTimeout on an invalid timer id
        var optionCount = this.props.items.filter(ListItemUtils_1.isSelectableItem).length;
        var formattedOptionCount = Localize_1.Formatters.formatCount(optionCount);
        this.announceTimeoutId = window.setTimeout(function () {
            return LiveAnnouncer_1.LiveAnnouncer.announce(exports.FilteringListMessages.optionCountAnnouncement({ optionCount: optionCount, formattedOptionCount: formattedOptionCount }), 'assertive');
        }, timeout);
    };
    FilteringList.prototype.getFirstSelectedValue = function () {
        var _a;
        // this seems stupid but actually it's terrible
        // https://salesforce-internal.slack.com/archives/CB5KQ7Y31/p1667425583470669
        return ((_a = this.props.selectedValues) === null || _a === void 0 ? void 0 : _a.values().next().value) || this.props.selectedValue || undefined;
    };
    FilteringList.prototype.moveSelection = function (start, direction) {
        this.setState({ activeItemIndex: ListItemUtils_1.findFocusableItemIndex(this.props.items, start, direction) });
    };
    FilteringList.prototype.render = function () {
        var _this = this;
        // eslint-disable-next-line max-len
        var _a = this.props, ariaLabel = _a["aria-label"], ariaLabelledby = _a["aria-labelledby"], autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, children = _a.children, className = _a.className, listTestId = _a.listTestId, inputTestId = _a.inputTestId, items = _a.items, label = _a.label, labelId = _a.labelId, listId = _a.listId, onFilterChange = _a.onFilterChange, onSelect = _a.onSelect, onSelectAll = _a.onSelectAll, searchPlaceholder = _a.searchPlaceholder, searchText = _a.searchText, selectOnEnterKey = _a.selectOnEnterKey, selectedValue = _a.selectedValue, selectedValues = _a.selectedValues, style = _a.style, testId = _a.testId, htmlAttrs = tslib_1.__rest(_a, ['aria-label', 'aria-labelledby', "autoComplete", "autoFocus", "children", "className", "listTestId", "inputTestId", "items", "label", "labelId", "listId", "onFilterChange", "onSelect", "onSelectAll", "searchPlaceholder", "searchText", "selectOnEnterKey", "selectedValue", "selectedValues", "style", "testId"]);
        var _b = this.state, activeItemIndex = _b.activeItemIndex, focusWithin = _b.focusWithin, width = _b.width;
        return React.createElement(DropdownOverlay_1.DropdownPositionedAboveContext.Consumer, null, function (reverse) {
            return React.createElement("div", tslib_1.__assign({}, htmlAttrs, { className: TypeStyle.classes(ListStyles_1.FilteringListStyleName, reverse && 'reverse', className), "data-tb-test-id": testId, onBlur: _this.handleBlur, onFocusCapture: _this.handleFocusCapture, onKeyDown: _this.handleKeyDown, onKeyUp: _this.handleKeyUp, ref: _this.handleDivRef, style: tslib_1.__assign({ width: width }, style) }),
                React.createElement(TextFieldWidget_1.TextFieldWidget, { "aria-activedescendant": activeItemIndex > -1 ? _this.listId() + "-" + activeItemIndex : undefined, "aria-autocomplete": 'list', "aria-controls": _this.listId(), "aria-expanded": true, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : _this.labelId(), autoComplete: autoComplete, className: FieldWrapperStyleName, kind: 'search', label: label, labelId: _this.labelId(), onBlur: _this.handleInputBlur, onChange: _this.handleInputChange, onClear: _this.clearInput, onFocus: _this.handleInputFocus, placeholder: searchPlaceholder, ref: _this.updateInputRef, role: 'combobox', style: FieldStyle, testId: inputTestId, value: searchText || '' }),
                children,
                React.createElement(List_1.ListIsActiveContext.Provider, { value: focusWithin && activeItemIndex > -1 },
                    React.createElement(List_1.List
                    // ARIA WG agrees that this is duplicative but requires it nonetheless 😞 https://github.com/w3c/aria/issues/1725
                    , tslib_1.__assign({ "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : _this.labelId(), id: _this.listId(), items: items, onSelect: onSelect, ref: _this.listRef }, (selectedValues ? { selectedValues: selectedValues, onSelectAll: onSelectAll } : { selectedValue: selectedValue }), { selectOnEnterKey: false, tabIndex: -1, testId: listTestId }))));
        });
    };
    return FilteringList;
}(React.PureComponent));
exports.FilteringList = FilteringList;
//# sourceMappingURL=FilteringList.js.map